import { useTranslation } from 'react-i18next';

export const useCloudMessageTranslation = () => {
  const { t } = useTranslation();

  return {
    cloudMessageTranslation: (message: string) =>
      t(`dashboard.authentication.cloudMessage.${message}`),
  };
};
